
import { createRouter, createWebHashHistory } from 'vue-router';
export default ({ store, auth }) => {
	let routes = [
		//activities routes
		{
			path: '/activities/:index?/:fieldName?/:fieldValue?',
			name: 'activitieslist',
			component: () => import('./pages/activities/list.vue'),
			props: true
		},

		//app_downloads routes
		{
			path: '/app_downloads/:index?/:fieldName?/:fieldValue?',
			name: 'app_downloadslist',
			component: () => import('./pages/app_downloads/list.vue'),
			props: true
		},
		{
			path: '/app_downloads/view/:id',
			name: 'app_downloadsview',
			component: () => import('./pages/app_downloads/view.vue'),
			props: true
		},

		//chats routes
		{
			path: '/chats/:index?/:fieldName?/:fieldValue?',
			name: 'chatslist',
			component: () => import('./pages/chats/list.vue'),
			props: true
		},
		{
			path: '/chats/add',
			name: 'chatsadd',
			component: () => import('./pages/chats/add.vue'),
			props: true
		},
		{
			path: '/chats/edit/:id',
			name: 'chatsedit',
			component: () => import('./pages/chats/edit.vue'),
			props: true
		},
		{
			path: '/clients/view/:id',
			name: 'clientsview',
			component: () => import('./pages/clients/view.vue'),
			props: true
		},
		{
			path: '/clients/edit/:id',
			name: 'clientsedit',
			component: () => import('./pages/clients/edit.vue'),
			props: true
		},

		//cdr routes
		{
			path: '/cdr/:index?/:fieldName?/:fieldValue?',
			name: 'cdrlist',
			component: () => import('./pages/cdr/list.vue'),
			props: true
		},
		{
			path: '/cdr/view/:id',
			name: 'cdrview',
			component: () => import('./pages/cdr/view.vue'),
			props: true
		},

		//complaints routes
		{
			path: '/complaints/:index?/:fieldName?/:fieldValue?',
			name: 'complaintslist',
			component: () => import('./pages/complaints/list.vue'),
			props: true
		},
		{
			path: '/complaints/view/:id',
			name: 'complaintsview',
			component: () => import('./pages/complaints/view.vue'),
			props: true
		},
		{
			path: '/complaints/add',
			name: 'complaintsadd',
			component: () => import('./pages/complaints/add.vue'),
			props: true
		},
		{
			path: '/complaints/add/:id',
			name: 'complaintsaddcustomer',
			component: () => import('./pages/complaints/add.vue'),
			props: true
		},
		{
			path: '/complaints/add/:id?/:action?',
			name: 'complaintsaddcustomer',
			component: () => import('./pages/complaints/add.vue'),
			props: true
		},
		{
			path: '/complaints/edit/:id',
			name: 'complaintsedit',
			component: () => import('./pages/complaints/edit.vue'),
			props: true
		},
		{
			path: '/complaints/sublist/:index?/:fieldName?/:fieldValue?',
			name: 'complaintssublist',
			component: () => import('./pages/complaints/sublist.vue'),
			props: true
		},

		//complaints_list routes
		{
			path: '/complaints_list/:index?/:fieldName?/:fieldValue?',
			name: 'complaints_listlist',
			component: () => import('./pages/complaints_list/list.vue'),
			props: true
		},

		//customers routes
    {
			path: '/customers/:index?/:fieldName?/:fieldValue?',
			name: 'customerslist',
			component: () => import('./pages/customers/list.vue'),
			props: true
		},
		{
			path: '/customers/view/:id',
			name: 'customersview',
			component: () => import('./pages/customers/view.vue'),
			props: true
		},

		//feeds routes
		{
			path: '/feeds/:index?/:fieldName?/:fieldValue?',
			name: 'feedslist',
			component: () => import('./pages/feeds/list.vue'),
			props: true
		},
		{
			path: '/feeds/view/:id',
			name: 'feedsview',
			component: () => import('./pages/feeds/view.vue'),
			props: true
		},
		{
			path: '/feeds/add',
			name: 'feedsadd',
			component: () => import('./pages/feeds/add.vue'),
			props: true
		},
		{
			path: '/feeds/edit/:id',
			name: 'feedsedit',
			component: () => import('./pages/feeds/edit.vue'),
			props: true
		},

		//meters routes
		{
			path: '/meters/:index?/:fieldName?/:fieldValue?',
			name: 'meterslist',
			component: () => import('./pages/meters/list.vue'),
			props: true
		},
		{
			path: '/meters/view/:id',
			name: 'metersview',
			component: () => import('./pages/meters/view.vue'),
			props: true
		},

		//offices routes
		{
			path: '/offices/:index?/:fieldName?/:fieldValue?',
			name: 'officeslist',
			component: () => import('./pages/offices/list.vue'),
			props: true
		},
		{
			path: '/offices/add',
			name: 'officesadd',
			component: () => import('./pages/offices/add.vue'),
			props: true
		},
		{
			path: '/offices/edit/:id',
			name: 'officesedit',
			component: () => import('./pages/offices/edit.vue'),
			props: true
		},

		//payment_history routes
		{
			path: '/payment_history/:index?/:fieldName?/:fieldValue?',
			name: 'payment_historylist',
			component: () => import('./pages/payment_history/list.vue'),
			props: true
		},

		{
			path: '/payment_history/view/:id',
			name: 'payment_historyview',
			component: () => import('./pages/payment_history/view.vue'),
			props: true
		},
		{
			path: '/payment_history/sublist/:index?/:fieldName?/:fieldValue?',
			name: 'payment_historysublist',
			component: () => import('./pages/payment_history/sublist.vue'),
			props: true
		},

		//region_districts routes
		{
			path: '/region_districts/:index?/:fieldName?/:fieldValue?',
			name: 'region_districtslist',
			component: () => import('./pages/region_districts/list.vue'),
			props: true
		},
		{
			path: '/region_districts/add',
			name: 'region_districtsadd',
			component: () => import('./pages/region_districts/add.vue'),
			props: true
		},
		{
			path: '/region_districts/edit/:id',
			name: 'region_districtsedit',
			component: () => import('./pages/region_districts/edit.vue'),
			props: true
		},

		//user_permissions routes
		{
			path: '/user_permissions/:index?/:fieldName?/:fieldValue?',
			name: 'user_permissionslist',
			component: () => import('./pages/user_permissions/list.vue'),
			props: true
		},
		{
			path: '/user_permissions/add',
			name: 'user_permissionsadd',
			component: () => import('./pages/user_permissions/add.vue'),
			props: true
		},

		//user_roles routes
		{
			path: '/user_roles/:index?/:fieldName?/:fieldValue?',
			name: 'user_roleslist',
			component: () => import('./pages/user_roles/list.vue'),
			props: true
		},
		{
			path: '/user_roles/view/:id',
			name: 'user_rolesview',
			component: () => import('./pages/user_roles/view.vue'),
			props: true
		},
		{
			path: '/user_roles/add',
			name: 'user_rolesadd',
			component: () => import('./pages/user_roles/add.vue'),
			props: true
		},
		{
			path: '/user_roles/edit/:id',
			name: 'user_rolesedit',
			component: () => import('./pages/user_roles/edit.vue'),
			props: true
		},

		//users routes
		{
			path: '/users/:index?/:fieldName?/:fieldValue?',
			name: 'userslist',
			component: () => import('./pages/users/list.vue'),
			props: true
		},
		{
			path: '/users/view/:id',
			name: 'usersview',
			component: () => import('./pages/users/view.vue'),
			props: true
		},
		{
			path: '/account/edit',
			name: 'usersaccountedit',
			component: () => import('./pages/account/accountedit.vue'),
			props: true
		},

		//Reports
		{
			path: '/reports',
			name: 'reports',
			component: () => import('./pages/reports/list.vue'),
			props: true
		},
		{
			path: '/ebilling/customers',
			name: 'ebillingcustomers',
			component: () => import('./pages/ebilling/customers.vue'),
			props: true
		},
		{
			path: '/ebilling/statements',
			name: 'ebillingstatements',
			component: () => import('./pages/ebilling/statements.vue'),
			props: true
		},


		{
			path: '/account',
			name: 'usersaccountview',
			component: () => import('./pages/account/accountview.vue'),
			props: true
		},

		{
			path: '/users/add',
			name: 'usersadd',
			component: () => import('./pages/users/add.vue'),
			props: true
		},

		{
			path: '/users/edit/:id',
			name: 'usersedit',
			component: () => import('./pages/users/edit.vue'),
			props: true
		},
		{
			path: '/users/reset/:id',
			name: 'usersreset',
			component: () => import('./pages/users/reset.vue'),
			props: true
		},


		//Index reset routes
		{
			path: '/index/accountblocked',
			name: 'accountblocked',
			component: () => import('./pages/index/accountblocked.vue'),
			props: true
		},

		{
			path: '/index/accountinactive',
			name: 'accountinactive',
			component: () => import('./pages/index/accountinactive.vue'),
			props: true
		},

		// Custom Pages
		{
			path: '/custom/whatsnew',
			name: 'whatsnew',
			component: () => import('./pages/custom/whatsnew.vue'),
			props: true
		},


		//Password reset routes
		{
			path: '/index/forgotpassword',
			name: 'forgotpassword',
			component: () => import('./pages/index/forgotpassword.vue'),
			props: true
		},
		{
			path: '/index/resetpassword',
			name: 'resetpassword',
			component: () => import('./pages/index/resetpassword.vue'),
			props: true
		},
		{
			path: '/index/resetpassword_completed',
			name: 'resetpassword_completed',
			component: () => import('./pages/index/resetpassword_completed.vue'),
			props: true
		},



		{
			path: '/error/forbidden',
			name: 'forbidden',
			component: () => import('./pages/errors/forbidden.vue'),
			props: true
		},
		{
			path: '/error/notfound',
			name: 'notfound',
			component: () => import('./pages/errors/pagenotfound.vue'),
			props: true
		},
		{
			path: '/:catchAll(.*)',
			component: () => import('./pages/errors/pagenotfound.vue')
		}
	];

	const user = store.state.auth.user;
	if (user) {
		routes.push({ path: '/', alias: '/home', name: 'home', component: () => import(`./pages/home/home.vue`) });
	}
	else {
		routes.push({ path: '/', alias: '/index', name: 'index', component: () => import('./pages/index/index.vue') });
	}


	const router = createRouter({
		history: createWebHashHistory(),
		routes,
		scrollBehavior(to, from, savedPostion) {
			//if(savedPostion) return savedPostion;
			return { x: 0, y: 0 }
		}
	});


	router.beforeEach((to, from, next) => {
		const user = store.state.auth.user;
		let path = to.path;

		let authRequired = auth.pageRequiredAuth(path);
		if (authRequired) {
			if (!user) {
				return next({ path: '/', query: { nexturl: to.fullPath } });
			}
			//authorize user
			if (!auth.canView(path)) {
				return next({ path: "/error/forbidden" });
			}
		}

		if (user && to.name == "index") {
			//already logged in, show home when try to access index page
			return next({ path: "/home" });
		}

		//navigate to redirect url if available
		if (to.name == "home" && to.query.nexturl) {
			return next({ path: to.query.nexturl });
		}

		//close dialog from previous page
		store.dispatch('app/closeDialogs');


		next();
	});

	return router;
}
